import React, { useEffect, useCallback } from 'react';
import { debounce } from 'lodash-es';
import { setWindowWidth } from '@/state/global/actions';
import { useAppDispatch } from '@/utils/hooks';

type Props = {
    // OwnProps
};

const WindowSizeListener: React.FC<Props> = (props) => {
    const dispatch = useAppDispatch();

    const setWidth = useCallback(() => {
        dispatch(setWindowWidth(window.innerWidth));
    }, [dispatch]);

    useEffect(() => {
        const handleResize = debounce(() => {
            setWidth();
        }, 20);

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setWidth]);
    return null;
};

export default WindowSizeListener;
